<div
  mat-dialog-title
  fxLayout="row"
  fxLayoutAlign="center center"
  class="replace-materials-dialog__header"
>
  <h3 class="inline-block flex-none push-right" i18n>Bulk replace materials</h3>
  <div class="replace-materials-dialog__header-search">
    <mat-form-field fxFlex>
      <mat-label i18n>Search</mat-label>
      <input matInput (keyup)="applyFilter($event)" />
    </mat-form-field>
    <button
      class="flex-none"
      mat-icon-button
      matTooltip="Sort by name"
      matTooltipPosition="above"
      i18n-matTooltip
      (click)="sortList()"
    >
      <mat-icon>sort</mat-icon>
    </button>
  </div>
</div>
<div mat-dialog-content fxFlex="auto">
  <mat-nav-list>
    <ng-container *ngFor="let element of displayedElements">
      <mat-list-item
        class="replace-materials-dialog__list-item"
        [ngClass]="elementRowClasses(element)"
      >
        <span class="replace-materials-dialog__list-item-name">{{
          element.name
        }}</span>
        <span class="flex-auto"></span>
        <span class="replace-materials-dialog__list-item-material">{{
          element.replaceMaterial
        }}</span>
        <button
          *ngIf="element.replaceMaterial"
          (click)="clearMaterial(element)"
          mat-icon-button
        >
          <mat-icon>delete</mat-icon>
        </button>
        <button
          mat-raised-button
          color="primary"
          (click)="selectMaterial(element)"
          i18n
        >
          SELECT
        </button>
      </mat-list-item>
      <mat-divider></mat-divider>
    </ng-container>
  </mat-nav-list>
</div>

<div mat-dialog-actions>
  <span class="flex-auto"></span>
  <button mat-raised-button color="accent" (click)="replaceAll()" i18n>
    OK
  </button>
  <button mat-raised-button color="primary" (click)="close()" i18n>
    CLOSE
  </button>
</div>
